var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_021f3bba"]},_vm.$listeners),[_c('div',{class:[("slot-item "+(_vm.activeClass))]},[_c('div',{class:["slot-item-text"]},[_vm._v(_vm._s(_vm.index + 1)+_vm._s(_vm.txt))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }